module.exports = __webpack_public_path__ + "static/img/7.ace2f32.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/9/zh/7.png
// module id = 4Yae
// module chunks = 0